/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "ម្សិលមិញ",
        "-2": "ម្សិល​ម៉្ងៃ",
        "0": "ថ្ងៃ​នេះ",
        "1": "ថ្ងៃ​ស្អែក",
        "2": "​ខាន​ស្អែក",
        "future": {
          "other": "{0} ថ្ងៃទៀត"
        },
        "past": {
          "other": "{0} ថ្ងៃ​មុន"
        }
      },
      "day-narrow": {
        "-1": "ម្សិលមិញ",
        "-2": "ម្សិល​ម៉្ងៃ",
        "0": "ថ្ងៃ​នេះ",
        "1": "ថ្ងៃស្អែក",
        "2": "​ខាន​ស្អែក",
        "future": {
          "other": "{0} ថ្ងៃទៀត"
        },
        "past": {
          "other": "{0} ថ្ងៃ​​មុន"
        }
      },
      "day-short": {
        "-1": "ម្សិលមិញ",
        "-2": "ម្សិល​ម៉្ងៃ",
        "0": "ថ្ងៃ​នេះ",
        "1": "ថ្ងៃស្អែក",
        "2": "​ខាន​ស្អែក",
        "future": {
          "other": "{0} ថ្ងៃទៀត"
        },
        "past": {
          "other": "{0} ថ្ងៃ​​មុន"
        }
      },
      "hour": {
        "0": "ម៉ោងនេះ",
        "future": {
          "other": "ក្នុង​រយៈ​ពេល {0} ម៉ោង"
        },
        "past": {
          "other": "{0} ម៉ោង​មុន"
        }
      },
      "hour-narrow": {
        "0": "ម៉ោងនេះ",
        "future": {
          "other": "{0} ម៉ោងទៀត"
        },
        "past": {
          "other": "{0} ម៉ោង​មុន"
        }
      },
      "hour-short": {
        "0": "ម៉ោងនេះ",
        "future": {
          "other": "{0} ម៉ោងទៀត"
        },
        "past": {
          "other": "{0} ម៉ោង​មុន"
        }
      },
      "minute": {
        "0": "នាទីនេះ",
        "future": {
          "other": "{0} នាទីទៀត"
        },
        "past": {
          "other": "{0} នាទី​មុន"
        }
      },
      "minute-narrow": {
        "0": "នាទីនេះ",
        "future": {
          "other": "{0} នាទីទៀត"
        },
        "past": {
          "other": "{0} នាទី​​មុន"
        }
      },
      "minute-short": {
        "0": "នាទីនេះ",
        "future": {
          "other": "{0} នាទីទៀត"
        },
        "past": {
          "other": "{0} នាទី​​មុន"
        }
      },
      "month": {
        "-1": "ខែ​មុន",
        "0": "ខែ​នេះ",
        "1": "ខែ​ក្រោយ",
        "future": {
          "other": "{0} ខែទៀត"
        },
        "past": {
          "other": "{0} ខែមុន"
        }
      },
      "month-narrow": {
        "-1": "ខែ​មុន",
        "0": "ខែ​នេះ",
        "1": "ខែ​ក្រោយ",
        "future": {
          "other": "{0} ខែទៀត"
        },
        "past": {
          "other": "{0} ខែមុន"
        }
      },
      "month-short": {
        "-1": "ខែ​មុន",
        "0": "ខែ​នេះ",
        "1": "ខែ​ក្រោយ",
        "future": {
          "other": "{0} ខែទៀត"
        },
        "past": {
          "other": "{0} ខែមុន"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "ត្រីមាស​មុន",
        "0": "ត្រីមាស​នេះ",
        "1": "ត្រីមាស​ក្រោយ",
        "future": {
          "other": "{0} ត្រីមាសទៀត"
        },
        "past": {
          "other": "{0} ត្រីមាស​មុន"
        }
      },
      "quarter-narrow": {
        "-1": "ត្រីមាស​មុន",
        "0": "ត្រីមាស​នេះ",
        "1": "ត្រីមាស​ក្រោយ",
        "future": {
          "other": "{0} ត្រីមាសទៀត"
        },
        "past": {
          "other": "{0} ត្រីមាស​មុន"
        }
      },
      "quarter-short": {
        "-1": "ត្រីមាស​មុន",
        "0": "ត្រីមាស​នេះ",
        "1": "ត្រីមាស​ក្រោយ",
        "future": {
          "other": "{0} ត្រីមាសទៀត"
        },
        "past": {
          "other": "{0} ត្រីមាស​មុន"
        }
      },
      "second": {
        "0": "ឥឡូវ",
        "future": {
          "other": "{0} វិនាទីទៀត"
        },
        "past": {
          "other": "{0} វិនាទី​មុន"
        }
      },
      "second-narrow": {
        "0": "ឥឡូវ",
        "future": {
          "other": "{0} វិនាទីទៀត"
        },
        "past": {
          "other": "{0} វិនាទី​មុន"
        }
      },
      "second-short": {
        "0": "ឥឡូវ",
        "future": {
          "other": "{0} វិនាទីទៀត"
        },
        "past": {
          "other": "{0} វិនាទី​មុន"
        }
      },
      "week": {
        "-1": "សប្ដាហ៍​មុន",
        "0": "សប្ដាហ៍​នេះ",
        "1": "សប្ដាហ៍​ក្រោយ",
        "future": {
          "other": "{0} សប្ដាហ៍ទៀត"
        },
        "past": {
          "other": "{0} សប្ដាហ៍​មុន"
        }
      },
      "week-narrow": {
        "-1": "សប្ដាហ៍​មុន",
        "0": "សប្ដាហ៍​នេះ",
        "1": "សប្ដាហ៍​ក្រោយ",
        "future": {
          "other": "{0} សប្ដាហ៍ទៀត"
        },
        "past": {
          "other": "{0} សប្ដាហ៍​មុន"
        }
      },
      "week-short": {
        "-1": "សប្ដាហ៍​មុន",
        "0": "សប្ដាហ៍​នេះ",
        "1": "សប្ដាហ៍​ក្រោយ",
        "future": {
          "other": "{0} សប្ដាហ៍ទៀត"
        },
        "past": {
          "other": "{0} សប្ដាហ៍​មុន"
        }
      },
      "year": {
        "-1": "ឆ្នាំ​មុន",
        "0": "ឆ្នាំ​នេះ",
        "1": "ឆ្នាំ​ក្រោយ",
        "future": {
          "other": "{0} ឆ្នាំទៀត"
        },
        "past": {
          "other": "{0} ឆ្នាំ​មុន"
        }
      },
      "year-narrow": {
        "-1": "ឆ្នាំ​មុន",
        "0": "ឆ្នាំ​នេះ",
        "1": "ឆ្នាំ​ក្រោយ",
        "future": {
          "other": "{0} ឆ្នាំទៀត"
        },
        "past": {
          "other": "{0} ឆ្នាំ​មុន"
        }
      },
      "year-short": {
        "-1": "ឆ្នាំ​មុន",
        "0": "ឆ្នាំ​នេះ",
        "1": "ឆ្នាំ​ក្រោយ",
        "future": {
          "other": "{0} ឆ្នាំទៀត"
        },
        "past": {
          "other": "{0} ឆ្នាំ​មុន"
        }
      }
    },
    "locale": "km"
  });
}